<template >
<div>
  <router-view v-slot="{ Component }">
    <!-- <transition  mode="out-in"> -->
      <!-- <keep-alive :include="cachedViews"> -->
        <component :is="Component" :key="$route.fullPath"/>
      <!-- </keep-alive> -->
    <!-- </transition> -->
  </router-view>
</div>

</template>
<script lang="ts">
import { useStore } from '@/store'
import { defineComponent, onBeforeMount, watch, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'Parentview',
  setup() {
    const store = useStore()
    const route = useRoute()
    const cachedViews = store.state.tagViews.cachedViews

    const state: any = reactive({
      cachedViews
    })

    watch(() => route.fullPath, () => {
      state.cachedViews = store.state.tagViews.cachedViews
    })
    onBeforeMount(() => {
      // do nothing
    })

    return {
      cachedViews,
      ...toRefs(state)
    }
  }
})
</script>
<style scoped>

</style>
